import { mercury, mineshaft } from '../colors';
export var MuiAppBar = {
    styleOverrides: {
        colorPrimary: {
            backgroundColor: mineshaft,
            color: mercury,
        },
    },
};
